module.exports = __webpack_public_path__ + "img/medesk.46984a29.png";